import clsx from "clsx";
import React from "react";

import { Loader } from "./loader";

export function Table({ className, ...props }: React.HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="table-scrollable tw-my-0">
      <table
        {...props}
        className={clsx("table table-bordered table-hover dataTable no-footer", className)}
      />
    </div>
  );
}

export function TableRow({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) {
  return <tr {...props} className={className} />;
}

export function TableHead({
  className,
  sort,
  ...props
}: React.ThHTMLAttributes<HTMLTableCellElement> & { sort?: "desc" | "asc" | "both" }) {
  const sortingClassNames = {
    desc: "sorting_desc",
    asc: "sorting_asc",
    both: "sorting",
  };
  return <th {...props} className={clsx(className, sort ? sortingClassNames[sort] : "")} />;
}

export function TableCell({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <td {...props} className={className} />;
}

export function TableLoading({ columns }: { columns: number }) {
  return (
    <TableRow>
      <TableCell colSpan={columns} className="tw-p-0.5 tw-text-center">
        <Loader className="sm:tw-justify-center" />
      </TableCell>
    </TableRow>
  );
}

export function TableEmpty({ columns, children }: { columns: number; children: React.ReactNode }) {
  return (
    <TableRow>
      <TableCell colSpan={columns} className="tw-p-3 tw-text-center">
        {children}
      </TableCell>
    </TableRow>
  );
}

export function TableError({ columns, children }: { columns: number; children: React.ReactNode }) {
  return (
    <TableRow>
      <TableCell
        colSpan={columns}
        className="tw-p-3 tw-text-center tw-font-semibold tw-text-red-500"
      >
        {children}
      </TableCell>
    </TableRow>
  );
}
